import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  makeStyles,
  Button,
  Table,
  TableHead,
  useMediaQuery,
  TableRow,
  TableCell,
  TableFooter,
  CircularProgress,
  TableBody,
  IconButton,
  Tooltip
} from "@material-ui/core";
import { invoicesBaseUrl, httpClient } from "../../http-client/http-client";
import { useTheme } from "@material-ui/styles";
import PdfIcon from "../../icons/Pdf";
import { compose } from "../../utils/compose";
import { connect } from "react-redux";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { invoicesActions } from "../../store/actions/invoices/invoices";

var useStyles = makeStyles(theme => ({
  strikeout: {
    '& td:not(:last-child)': {
      position: 'relative',
     '&:before': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '0',
      borderBottom: '1px solid #111',
      width: '100%',
    }
  }
  }
}));

const InvoiceTable = props => {
  const classes = useStyles();
  const { fetching, list, hasMore, onFetch, onFetchMore, access_token } = props;
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"));
  const { t } = useTranslation();

  const fetchData = (abortSignal) => {
    if (!hasMore) return;

    onFetchMore();
  };

  useEffect(() => {
    onFetch();
  }, []);

  const downloadInvoiceHandler = (event, id) => {
    console.log(`download pdf ${id}`);
    const url = `${invoicesBaseUrl}/${id}`;

    httpClient.get(url, access_token).then(
      data => {
        window.open(data.Url);
      },
      error => {
        console.log(error);
      }
    );
  };

  const downloadCreditNoteHandler = (event, cnId) => {
    console.log(`download credit note ${cnId}`);
    const url = `${invoicesBaseUrl}/cn/${cnId}`;

    httpClient.get(url, access_token).then(
      data => {
        window.open(data.Url);
      },
      error => {
        console.log(error);
      }
    );
  };

  const getTableRows = () => {
    return list.map(e => (
      <React.Fragment key={e.Id}>
        <TableRow className={clsx(e.CreditNotes.length > 0 ? classes.strikeout : "")}>
          <TableCell>{e.Id}</TableCell>
          <TableCell>{new Date(e.Date).toDateString()}</TableCell>
          {isMd ? (
            <>
              <TableCell>&euro;{e.SubTotal.Amount.toFixed(2)}</TableCell>
              <TableCell>&euro;{e.Discount.Amount.toFixed(2)}</TableCell>
              <Tooltip title={e.Tax.Description}>
                <TableCell>&euro;{e.Tax.Money.Amount.toFixed(2)}</TableCell>
              </Tooltip>
            </>
          ) : null}
          <TableCell>&euro;{e.Total.Amount.toFixed(2)}</TableCell>
          <TableCell>
            <Tooltip title={t('downloadInvoice')}>
              <IconButton
                onClick={ev => downloadInvoiceHandler(ev, e.Id)}
                color="primary"
              >
                <PdfIcon />
              </IconButton>
            </Tooltip>
            {e.CreditNotes.length > 0
              ? e.CreditNotes.map(cn => (
                  <Tooltip title={t('downloadCreditNote')} key={cn.Id}>
                    <IconButton
                      onClick={ev => downloadCreditNoteHandler(ev, cn.Id)}
                      color="secondary"
                    >
                      <PdfIcon />
                    </IconButton>
                  </Tooltip>
                ))
              : null}
          </TableCell>
        </TableRow>
      </React.Fragment>
    ));
  };

  return (
    <>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>{t('id')}</TableCell>
            <TableCell>{t('date')}</TableCell>
            {isMd ? (
              <>
                <TableCell>{t('price')}</TableCell>
                <TableCell>{t('discount')}</TableCell>
                <TableCell>{t('tax')}</TableCell>
              </>
            ) : null}
            <TableCell>{t('total')}</TableCell>
            <TableCell>{t('actionListLabel')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{getTableRows()}</TableBody>

        <TableFooter>
          {fetching ? (
            <TableRow>
              <TableCell colSpan={isMd ? 7 : 4} align="center">
                <CircularProgress />
              </TableCell>
            </TableRow>
          ) : null}
          <TableRow>
            <TableCell colSpan={isMd ? 7 : 4} align="center">
              <Button disabled={!hasMore || fetching} onClick={fetchData}>
                {t('loadMore')}
              </Button>
            </TableCell>
          </TableRow>
        </TableFooter>

      </Table>
    </>
  );
};

InvoiceTable.propTypes = {};

const mapStateToProps = state => ({
  access_token: state.oidc.user.access_token,
  fetching: state.invoices.fetching,
  list: state.invoices.data,
  error: state.invoices.error,
  hasMore: state.invoices.nextOffset !== null
});

const mapDispatchToProps = dispatch => ({
  onFetch: () => dispatch(invoicesActions.fetch()),
  onFetchMore: () => dispatch(invoicesActions.fetchMore())
});

const composed = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(InvoiceTable);

export default composed;
